<div class="container">
    <mat-slide-toggle [(ngModel)]="assumption.IsEnabled">Assumption applied</mat-slide-toggle>
    <div *ngIf="assumption.IsEnabled">
        <textarea class="text-field" [(ngModel)]="assumption.AttributeValue"
            placeholder="Assumption notes" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
    </div>
</div>
